<template>
  <v-main>
    <v-container fluid>
      <v-row>
        <v-col md="12">
          <v-card elevation="6" rounded="xxl">
            <v-card-title>
              <h3
                class="font-weight-bold"
                v-text="
                  isDeletePage() != true
                    ? 'Recharged Benefits'
                    : 'Deleted Recharged Benefits'
                "
              ></h3>
              <section v-if="isDeletePage() != true">
                <v-btn
                  class="mx-2 mb-2"
                  fab
                  x-small
                  color="primary"
                  to="/rechargedbenefits/create"
                >
                  <v-icon dark> mdi-plus </v-icon>
                </v-btn>
              </section>
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col md="6">
                  <v-text-field
                    solo
                    rounded
                    v-model="filter.search_keyword"
                    label="Search ... "
                    prepend-inner-icon="mdi-magnify"
                    clearable
                    @click:clear="
                      (filter.search_keyword = null), (page = 1), getData()
                    "
                    @keydown.enter="(page = 1), getData()"
                  ></v-text-field>
                </v-col>
                <v-col sm="2">
                  <v-autocomplete
                    solo
                    rounded
                    ref="reward_type"
                    v-model="filter.reward_type"
                    :items="rewardTypes"
                    label="Reward Type"
                    @input="(page = 1), getData()"
                    prepend-inner-icon="mdi-trophy"
                    clearable
                  ></v-autocomplete>
                </v-col>
                <v-col sm="2">
                  <v-autocomplete
                    solo
                    rounded
                    ref="store_item"
                    v-model="filter.store_item_id"
                    :items="storeItems"
                    item-text="text"
                    item-value="value"
                    label="Store Item"
                    @input="(page = 1), getData()"
                    prepend-inner-icon="mdi-store"
                    clearable
                  ></v-autocomplete>
                </v-col>
                <v-col sm="2">
                  <v-autocomplete
                    ref="status"
                    solo
                    rounded
                    v-model="filter.is_active"
                    :items="statuses"
                    label="Status"
                    @input="(page = 1), getData()"
                    prepend-inner-icon="mdi-toggle-switch"
                    clearable
                  ></v-autocomplete>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <v-row>
        <v-col md="12">
          <v-card elevation="6" rounded="xxl">
            <v-card-title v-if="rechargedBenefits.length != 0">
              <v-spacer></v-spacer>
              <v-btn
                rounded
                class="primary mx-4"
                @click="generateExcel()"
                v-if="isDeletePage() != true"
              >
                <span v-if="isExcelloading"> Generating Excel... </span>
                <span v-else>Generate Excel</span>
              </v-btn>
            </v-card-title>
            <v-card-text>
              <section v-if="isLoading" style="height: 285px">
                <v-progress-linear
                  indeterminate
                  color="primary"
                ></v-progress-linear>
              </section>
              <v-simple-table
                v-else
                fixed-header
                height="285"
                class="striped-table"
              >
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left">Sr No</th>
                      <th class="text-left">Status</th>
                      <th class="text-left">Title</th>
                      <th class="text-left">Rewards Count</th>
                      <th class="text-left">Rewards Details</th>
                      <th class="text-left">Recharge Amount</th>
                      <th class="text-left">Created Date</th>
                      <th class="text-right action_th">Action</th>
                    </tr>
                  </thead>
                  <tbody v-if="rechargedBenefits.length != 0">
                    <tr
                      v-for="(rechargedBenefit, i) in rechargedBenefits"
                      :key="`rechargedBenefit${i}`"
                    >
                      <td style="min-width: 85px">
                        {{ i + 1 }}
                      </td>
                      <td>
                        <v-tooltip
                          bottom
                          v-if="rechargedBenefit.is_active == 1"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              v-on="on"
                              small
                              color="teal"
                              text-color="white"
                            >
                              <v-avatar left>
                                <v-icon size="15"
                                  >mdi-checkbox-marked-circle</v-icon
                                >
                              </v-avatar>
                              Active
                            </v-chip>
                          </template>
                          <span>Recharged Benefit is Active</span>
                        </v-tooltip>
                        <v-tooltip
                          bottom
                          v-if="rechargedBenefit.is_active == 0"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              v-on="on"
                              small
                              color="red"
                              text-color="white"
                            >
                              <v-avatar left>
                                <v-icon size="15">mdi-close-circle</v-icon>
                              </v-avatar>
                              Inactive
                            </v-chip>
                          </template>
                          <span>Recharged Benefit is InActive</span>
                        </v-tooltip>
                      </td>
                      <td>{{ rechargedBenefit.title || "" }}</td>
                      <td>
                        <v-chip small color="purple" text-color="white">
                          {{ rechargedBenefit.rewards.length }} Rewards
                        </v-chip>
                      </td>
                      <td style="max-width: 300px;">
                        <div v-for="(reward, idx) in rechargedBenefit.rewards" :key="idx" class="mb-1">
                          <v-chip
                            x-small
                            :color="reward.reward_type === 'coin' ? 'amber' : 'blue'"
                            text-color="white"
                            class="mr-1"
                          >
                            {{ reward.reward_type === "coin" ? "Coin" : "Item" }}
                          </v-chip>
                          <span v-if="reward.reward_type === 'coin'">
                            {{ reward.coin_amount || 0 }} Coins
                          </span>
                          <span v-else>
                            {{ reward.store_item ? reward.store_item.name : "Item" }}
                            <span v-if="reward.duration > 0">({{ reward.duration }}d)</span>
                            <span v-else>(Permanent)</span>
                          </span>
                        </div>
                      </td>
                      <td>${{ rechargedBenefit.recharge_amount || 0 }}</td>
                      <td>{{ formatDate(rechargedBenefit.created_at) }}</td>

                      <td class="text-right">
                        <template v-if="isDeletePage() != true">
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                fab
                                x-small
                                class="my-auto"
                                color="error"
                                @click="deletePackage(rechargedBenefit)"
                              >
                                <v-icon dark> mdi-delete </v-icon>
                              </v-btn>
                            </template>
                            <span>Delete this benefit package</span>
                          </v-tooltip>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                class="ml-2"
                                fab
                                x-small
                                color="primary"
                                :to="`/rechargedbenefits/${encryptIt(
                                  rechargedBenefit.id
                                )}`"
                              >
                                <v-icon dark> mdi-pencil </v-icon>
                              </v-btn>
                            </template>
                            <span>Edit this benefit package</span>
                          </v-tooltip>
                        </template>
                        <template v-else>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                fab
                                x-small
                                class="my-auto"
                                color="error"
                                @click="restorePackage(rechargedBenefit)"
                              >
                                <v-icon dark> mdi-delete-restore </v-icon>
                              </v-btn>
                            </template>
                            <span>Restore this benefit package</span>
                          </v-tooltip>
                        </template>
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr>
                      <td colspan="8" class="text-center">No data found</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
              <v-pagination v-model="page" :length="paginationLength">
              </v-pagination>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <!-- Clear Success Dialog Box -->
      <v-dialog v-model="is_deleted_rechargedBenefit" width="600">
        <v-card rounded="xxl">
          <v-container>
            <v-row align="center">
              <v-col sm="3" align="center">
                <v-icon
                  large
                  style="color: green; font-size: 90px; width: 200px !important"
                >
                  mdi-delete-empty
                </v-icon>
              </v-col>
              <v-col sm="9" align="center">
                <v-card-text>
                  <v-row>
                    <v-col>
                      <h1 style="color: green">Hurray!</h1>
                      <br />
                      <h3>Recharged Benefit deleted successfully.</h3>
                      <br />
                      <v-btn
                        color="success"
                        @click="is_deleted_rechargedBenefit = false"
                      >
                        OK
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>
      <!-- Restore Success Dialog Box -->
      <v-dialog v-model="is_restored_rechargedBenefit" width="600">
        <v-card rounded="xxl">
          <v-container>
            <v-row align="center">
              <v-col sm="3" align="center">
                <v-icon
                  large
                  style="color: green; font-size: 90px; width: 200px !important"
                >
                  mdi-delete-restore
                </v-icon>
              </v-col>
              <v-col sm="9" align="center">
                <v-card-text>
                  <v-row>
                    <v-col>
                      <h1 style="color: green">Hurray!</h1>
                      <br />
                      <h3>Recharged Benefit restored successfully.</h3>
                      <br />
                      <v-btn
                        color="success"
                        @click="is_restored_rechargedBenefit = false"
                      >
                        OK
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>
    </v-container>
  </v-main>
</template>

<script>
import axios from "axios";
export default {
  name: "rechargedBenefitsPage",
  data() {
    return {
      filter: {
        reward_type: "",
        store_item_id: "",
        is_active: "",
        show_deleted: false,
      },
      page: 1,
      serialNoStarting: 1,
      paginationLength: 0,
      count: 0,
      is_deleted_rechargedBenefit: false,
      restore_rechargedBenefit: false,
      is_restored_rechargedBenefit: false,
      rechargedBenefits: [],
      rewardTypes: [
        {
          id: 0,
          text: "Select Reward Type",
          value: "",
        },
        { id: "coin", text: "Coin", value: "coin" },
        { id: "store_item", text: "Store Item", value: "store_item" },
      ],
      statuses: [
        {
          id: 0,
          text: "Select Active Status",
          value: "",
        },
        { id: "ACTIVE", text: "ACTIVE", value: "1" },
        { id: "INACTIVE", text: "INACTIVE", value: "0" },
      ],
      storeItems: [
        {
          id: 0,
          text: "Select Store Item",
          value: "",
        },
      ],
      isLoading: false,
      isExcelloading: false,
    };
  },
  watch: {
    page: "getData",
    $route() {
      this.getData();
    },
  },
  mounted() {
    this.getData();
    this.getMasters();
  },
  methods: {
    async getMasters() {
      await axios
        .get(`masters?context=reward_category`)
        .then((masters) => {
          masters = masters.data;
          //Store Items
          if (masters.storeItem) {
            masters.storeItem.forEach((storeItem) => {
              this.storeItems.push({
                id: storeItem.id,
                text: storeItem.name,
                value: storeItem.id,
              });
            });
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    async getData() {
      console.log("Get Data");
      this.filter.show_deleted = this.$route.query.open_trash ? 1 : 0;
      this.isLoading = true;
      this.filter.search_keyword = this.filter.search_keyword
        ? this.filter.search_keyword
        : "";
      this.filter.is_active = this.filter.is_active
        ? this.filter.is_active
        : "";
      this.filter.store_item_id = this.filter.store_item_id
        ? this.filter.store_item_id
        : "";
      this.filter.reward_type = this.filter.reward_type
        ? this.filter.reward_type
        : "";
      let query =
        "page=" +
        this.page +
        "&rowsPerPage=" +
        this.rowsPerPage +
        "&show_deleted=" +
        this.filter.show_deleted +
        "&is_active=" +
        this.filter.is_active +
        "&reward_type=" +
        this.filter.reward_type +
        "&store_item_id=" +
        this.filter.store_item_id +
        "&search_keyword=" +
        this.filter.search_keyword;
      await axios
        .get(`recharged_benefits?${query}`)
        .then((response) => {
          // Group benefits by title and recharge_amount
          const allRewards = response.data.data;
          const grouped = {};

          allRewards.forEach((reward) => {
            const key = `${reward.title}_${reward.recharge_amount}`;
            if (!grouped[key]) {
              grouped[key] = {
                id: reward.id, // Use first reward ID as representative
                title: reward.title,
                recharge_amount: reward.recharge_amount,
                is_active: reward.is_active,
                created_at: reward.created_at,
                rewards: [],
              };
            }
            grouped[key].rewards.push(reward);
          });

          // Convert grouped object to array
          this.rechargedBenefits = Object.values(grouped);
          this.count = this.rechargedBenefits.length;
          this.serialNoStarting = (this.page - 1) * this.rowsPerPage;
          this.paginationLength = Math.ceil(this.count / this.rowsPerPage);
        })
        .catch(function (error) {
          console.log(error);
        });
      this.isLoading = false;
    },
    async Delete_this(id) {
      this.delete_rechargedBenefit = true;
      await axios
        .post(`/recharged_benefits/delete/${this.encryptIt(id)}`)
        .then(() => {
          this.delete_rechargedBenefit = false;
          this.is_deleted_rechargedBenefit = true;
          this.getData();
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    async deletePackage(benefitPackage) {
      this.delete_rechargedBenefit = true;
      try {
        // Delete all rewards in this package
        const deletePromises = benefitPackage.rewards.map(reward =>
          axios.post(`/recharged_benefits/delete/${this.encryptIt(reward.id)}`)
        );
        await Promise.all(deletePromises);
        this.delete_rechargedBenefit = false;
        this.is_deleted_rechargedBenefit = true;
        this.getData();
      } catch (error) {
        console.log(error);
        this.delete_rechargedBenefit = false;
      }
    },
    async restorePackage(benefitPackage) {
      this.restore_rechargedBenefit = true;
      try {
        // Restore all rewards in this package
        const restorePromises = benefitPackage.rewards.map(reward =>
          axios.post(`/recharged_benefits/restore/${this.encryptIt(reward.id)}`)
        );
        await Promise.all(restorePromises);
        this.restore_rechargedBenefit = false;
        this.is_restored_rechargedBenefit = true;
        this.getData();
      } catch (error) {
        console.log(error);
        this.restore_rechargedBenefit = false;
      }
    },
    async generateExcel() {
      this.isExcelloading = true;
      this.filter.search_keyword = this.filter.search_keyword
        ? this.filter.search_keyword
        : "";
      this.filter.is_active = this.filter.is_active
        ? this.filter.is_active
        : "";
      this.filter.store_item_id = this.filter.store_item_id
        ? this.filter.store_item_id
        : "";
      this.filter.reward_type = this.filter.reward_type
        ? this.filter.reward_type
        : "";
      let query =
        "is_active=" +
        this.filter.is_active +
        "&reward_type=" +
        this.filter.reward_type +
        "&store_item_id=" +
        this.filter.store_item_id +
        "&search_keyword=" +
        this.filter.search_keyword;
      await axios
        .get(`/recharged_benefits/excel_export?${query}`)
        .then((response) => window.open(`${response.data.data}`, "_blank"));
      this.isExcelloading = false;
    },
    isDeletePage() {
      let response = false;
      if (this.$route.query.open_trash) {
        response = true;
      }
      return response;
    },
    async Restore_this(id) {
      this.restore_rechargedBenefit = true;
      await axios
        .post(`/recharged_benefits/restore/${this.encryptIt(id)}`)
        .then(() => {
          this.restore_rechargedBenefit = false;
          this.is_restored_rechargedBenefit = true;
          this.getData();
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    formatDate(date) {
      if (!date) return "";
      const options = { year: "numeric", month: "short", day: "numeric" };
      return new Date(date).toLocaleDateString("en-US", options);
    },
  },
};
</script>
